import { IAutoMapper } from "../interfaces";

export const mapAlertItemSupplemental = (automapper: IAutoMapper): void => {
    automapper
        .createMap("default", "AlertItemSupplemental")
        .forMember("createdBy", o => o.createdBy)
        .forMember("qualifiers", o => o.qualifiers);
};
